module.exports = __webpack_public_path__ + "img/1-2.9f07e3de.png";